import React, { useEffect, useState, useContext } from "react";
import { Button, ButtonLink } from "../../../misc/button/Button";
import SpinLoading from "../../../misc/loading/SpinLoading";
import { Form } from "antd";
import { DeclarationContext } from "../../../context/DeclarationWrapper";

export const TitleEditDeclarationModal = (
  props
  ) => {
  const { isAttestation } = useContext(DeclarationContext);
  const [headerTitle, setHeaderTitle] = useState("Déclaration à payer");

  useEffect(() => {
    const isAttestationType = isAttestation(props.record);
    let title;

    if (props.record?.status === 'modification_approved') {
      title = "Modification de déclaration";
    } else if (props.record?.status === 'pending_modification') {
      title = "Déclaration";
    } else if (props.record?.payed === "yes") {
      title = isAttestationType ? "Attestation générée" : "Déclaration payée";
    } else if (props.record?.payed === "ongoing") {
      title = "Déclaration en cours de traitement";
    } else {
      title = isAttestationType ? "Attestation" : "Déclaration à payer";
    }
    setHeaderTitle(title);
  }, [props.record, isAttestation])

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
      }}
    >
      <div>{headerTitle}</div>
      <div style={{ fontWeight: "normal", fontSize: 17, marginRight: 50 }}>
        {props.record?.indice > 0 && `Indice de facture : ${props.record?.indice}`}
      </div>
    </div>
  );
};

export const FooterEditDeclarationModal = ({
  mode,
  isLoading,
  onCloseModal,
  record,
  isAdmin,
}) => {
  const { isAttestation } = useContext(DeclarationContext);
  const editFooter = (
    <div className="button-container-modal-edit">
      <div>
        <Button text="Retour" onClick={onCloseModal}>
          Retour
        </Button>
      </div>
      <Form.Item>
        <Button
          text="Modifier"
          type="submit"
          children={isLoading ? <SpinLoading /> : "Modifier"}
        />
      </Form.Item>
    </div>
  );

  const isPayed = record?.payed === "yes";
  const isOngoingCB = record?.payed === "ongoing" && record?.paymentMethod === 'CB';
  const paymentMethod = record?.paymentMethod;
  // ongoing + virement : canPay reste true pour permettre le switch vers CB
  // ongoing + CB : canPay=false, nouvelle tentative bloquée
  const canPay = !isPayed && !isOngoingCB && record?.status === 'active' && !isAdmin && !isAttestation(record);
  const showCB = canPay;
  const showVirement = canPay && paymentMethod !== 'virement';
  const showOngoingCB = isOngoingCB && !isAdmin && !isAttestation(record);

  const viewFooter = (
    <div className="button-container-modal-view">
      <Button text="Retour" onClick={onCloseModal}>
        Retour
      </Button>
      {showOngoingCB && (
        <span style={{ color: 'orange' }}>Paiement CB en cours de traitement…</span>
      )}
      {showCB && (
        <ButtonLink
          to="/declaration-cb-page-v2"
          state={{ message: record }}
          children="Payer par CB"
        />
      )}
      {showVirement && (
        <ButtonLink
          to="/declaration-payment"
          state={{ message: record }}
          children=" Payer par virement"
        />
      )}
    </div>
  );

  return mode === "edit" ? editFooter : viewFooter;
};
